/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'ai-mate.chat-error-banner.description': 'Din chathistorik gemmes i op til 30 dage.',
  'ai-mate.chat-error-banner.title': 'Start ny chat',
  'ai-mate.chat-error.description': 'Prøv at <btn>genindlæse chat</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Du har nået det maksimale antal anmodninger. Prøv igen senere.',
  'ai-mate.chat-error.rate-limited-title': 'For mange anmodninger',
  'ai-mate.chat-error.rovo-inactive-description':
    'Det ser ud til, at Rovo ikke er aktiveret på dit website. <link>Opsætning af Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo er inaktiv',
  'ai-mate.chat-error.title': 'Vi er ikke sikre på, hvad der gik galt',
  'ai-mate.main-chat.close-chat-button-label': 'Luk',
  'ai-mate.main-chat.maximize-chat-button-label': 'Fuld skærm',
  'ai-mate.main-chat.minimize-chat-button-label': 'Gendan visning',
  'ai-mate.main-chat.new-chat-button-label': 'Ny',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Ny chat',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Send',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Spørg AI om dette',
  'highlight-actions.rovo-chat-explain-option.text': 'Forklar',
  'highlight-actions.rovo-chat-explain-prompt':
    'Forklar dette ved at omformulere det og tilføje yderligere oplysninger, men brug meget simpelt sprog og korte sætninger, og giv eksempler eller definitioner på eventuel teknisk terminologi, der er brugt i den oprindelige formulering.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Find ressourcer',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Find ressourcer udelukkende inden for organisatorisk viden, der støtter de foretagne erklæringer.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Giv eksempler',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Giv eksempler på dette fra organisationsressourcer eller offentlig viden. Hvis der ikke kan ydes nogen ressourcer, kan du forsøge at give et metaforisk eksempel, der muligvis kan hjælpe nogen med at forstå dette bedre.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Giv feedback',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Giv feedback ved at gennemgå formuleringen af dette. Kommentér på ordvalg, grammatik og tegnsætning. Vær positiv og entusiastisk, men angiv altid mindst én ting, der kan forbedres eller ændres.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chatanbefalinger',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Åbn Chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Opsummer',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Fremhæv de vigtigste punkter fra dette. Fokusér på essentielle oplysninger, og udeluk unødvendige detaljer. Giv et kortfattet overblik i et enkelt afsnit.',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Spørg i chat',
  'horizontal-scroll-container.scroll-left': 'Rul til venstre',
  'horizontal-scroll-container.scroll-right': 'Rul til højre',
};
